import { useState } from "react";
import "./ViewTraces.css";

const ViewTraces = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getJourneyId = () => {
    return window.location.pathname.split("/").pop();
  };

  const constructJaegerUrl = (journeyId) => {
    const tags = JSON.stringify({ "journey.id": journeyId });
    const encodedTags = encodeURIComponent(tags);
    return `http://localhost:16686/search?&service=chopin&tags=${encodedTags}`;
  };

  const handleViewTraces = (event) => {
    event.preventDefault();

    const journeyId = getJourneyId();
    const tracingUrl = constructJaegerUrl(journeyId);

    window.open(tracingUrl, "_blank");
    setIsDropdownOpen(false);
  };

  const handleDownloadJson = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const journeyId = getJourneyId();

      // Create download link to our backend route
      const link = document.createElement("a");
      link.href = `/dev_tools/traces/${journeyId}/download`;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading traces:", error);
      alert("Failed to access traces. Please try again.");
    } finally {
      setIsLoading(false);
      setIsDropdownOpen(false);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div id="view-traces-container">
      <button
        className="view-traces-merged-button"
        onClick={toggleDropdown}
        disabled={isLoading}
      >
        <span className="view-traces-text">Traces&nbsp;</span>
        <span className="view-traces-arrow">{isDropdownOpen ? "▼" : "▶"}</span>
      </button>
      {isDropdownOpen && (
        <div className="view-traces-dropdown">
          <button
            className="view-traces-dropdown-item"
            onClick={handleViewTraces}
            disabled={isLoading}
          >
            View in Jaeger
          </button>
          <button
            className="view-traces-dropdown-item"
            onClick={handleDownloadJson}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Download JSON"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewTraces;
